'use client'

import React, { useState } from 'react'
import { Pagination } from 'swiper/modules'
import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react'

import SliderNavigation from '~/layouts/shared/slider-navigation'
import { ISlideIconItem } from '~/types/strapi'

import SliderItem from './slider-item'

interface Props {
  sliderKey: string
  items: ISlideIconItem[]
  hidden?: boolean
}

const TabSliderMobile: React.FC<Props> = ({ items, sliderKey, hidden }) => {
  const [slider, setSlider] = useState<SwiperClass>()
  const [isBackDisable, setBackDisable] = useState(true)
  const [isNextDisable, setNextDisable] = useState(false)
  const [isPaginationEnabled, setPaginationEnabled] = useState(true)

  const paginationName = `slider-pagination-${sliderKey}-mobile`

  return (
    <div className="container lg:hidden w-full">
      <div>
        <Swiper
          slidesPerView={1}
          modules={[Pagination]}
          className="overflow-visible"
          pagination={{
            el: '.' + paginationName,
            clickable: true,
            renderBullet: (index, className) => {
              return '<span class="' + className + '"></span>'
            },
          }}
          spaceBetween={20}
          onInit={(swiper) => {
            setSlider(swiper)
            setPaginationEnabled(!swiper.isLocked)
          }}
          onSlideChange={(swiper) => {
            setBackDisable(swiper.isBeginning)
            setNextDisable(swiper.isEnd)
            setPaginationEnabled(!swiper.isLocked)
          }}
          autoHeight
          breakpoints={{
            560: {
              slidesPerView: 2,
            },
          }}
        >
          {items.map((item) => (
            <SwiperSlide key={`icons-slide-mobile-${item.id}`}>
              <SliderItem {...item} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      {isPaginationEnabled && (
        <SliderNavigation
          pagination={paginationName}
          onClickBack={() => slider.slidePrev()}
          onClickNext={() => slider.slideNext()}
          isBackDisable={isBackDisable}
          isNextDisable={isNextDisable}
          hidden={hidden}
        />
      )}
    </div>
  )
}

export default TabSliderMobile
